/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Part_6_TInputs */

const en_tut_part_6_t = /** @type {(inputs: Tut_Part_6_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A team that is never quite offline`)
};

const id_tut_part_6_t = /** @type {(inputs: Tut_Part_6_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim yang tidak pernah benar-benar offline`)
};

/**
* | output |
* | --- |
* | "A team that is never quite offline" |
*
* @param {Tut_Part_6_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_part_6_t = /** @type {((inputs?: Tut_Part_6_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Part_6_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_part_6_t(inputs)
	return en_tut_part_6_t(inputs)
});